<template>
  <div :class="classModifiers">
    <div class="market-trading-unavailable-v2__icon"></div>
    <div class="market-trading-unavailable-v2__text">
      <slot name="text"></slot>
    </div>
  </div>
</template>

<script src="./market-trading-unavailable-v2.js"></script>
<style src="./market-trading-unavailable-v2.scss" lang="scss"></style>
